import { render, staticRenderFns } from "./print-content.vue?vue&type=template&id=c58455e2&scoped=true"
import script from "./print-content.vue?vue&type=script&lang=js"
export * from "./print-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58455e2",
  null
  
)

export default component.exports